<template>
  <v-card :loading="loading" tile cols="12" md="4" xl="3" class="ma-2">

    <template slot="progress">
      <v-progress-linear
        color="primary"
        height="10"
        indeterminate
      ></v-progress-linear>
    </template>

    <v-card-title class="primary--text">
      <h3>{{ $t('kpi.' + kpi) }}</h3>
    </v-card-title>
    <v-card-text>
      <v-container fluid grid-list-xl class="mt-0 pt-0">
        <apexchart ref="kpi" width="500" type="line" :options="options" :series="series"></apexchart>
        <v-layout justify-center align-center>
          <v-btn text @click="changeDay(-1)"><v-icon>mdi-arrow-left-bold</v-icon></v-btn>
          <v-col class="pa-0" md="4">
            <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              :return-value.sync="date"
              transition="scale-transition"
              offset-y
              min-width="auto"
              style="position:relative;z-index:50;"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="date"
                  prepend-icon="mdi-calendar"
                  readonly
                  hide-details
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="date"
                no-title
                scrollable
                @change="changeDatePicker"
              >
                <v-spacer></v-spacer>
                <v-btn
                  text
                  color="primary"
                  @click="menu = false"
                >
                  Cancel
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="$refs.menu.save(date)"
                >
                  OK
                </v-btn>
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-btn text @click="changeDay(1)"><v-icon>mdi-arrow-right-bold</v-icon></v-btn>
        </v-layout>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import VueApexCharts from 'vue-apexcharts'

export default {
  props: ["kpi"],
  components: {
    "apexchart": VueApexCharts
  },
  data() {
    return {
      loading: false,
      options: {
        // timestamp
        xaxis: {
          categories: [],
          tickAmount: 24,
        }
      },
      series: [{
        name: this.$i18n.t('kpi.' + this.kpi),
        // sensor value
        data: []
      }],
      filterDate: new Date(Date.now()),
      menu: false,
    }
  },
  async mounted() {
    await this.updateData({ device: this.getCurrentDevice.deviceId, kpi: this.kpi, date: new Date().toISOString().substr(0, 10).replaceAll('-','') })
  },
  computed: {
    ...mapGetters(["getCurrentDevice","getCurrentDeviceHistoricalData"]),
    date: {
      get() {
        return new Date(this.filterDate).toISOString().substr(0, 10)
      },
      set(value) {
        this.$log.debug("set date", value)
      }
    }
  },
  methods: {
    ...mapActions(["doLoadHistoricalData"]),
    async updateData(graph) {
      this.loading = true
      await this.doLoadHistoricalData(graph)
      this.options = {...this.options, ...{
        xaxis: {
          categories: this.getCurrentDeviceHistoricalData[this.kpi].map(d => {
            let tmpd = new Date(0)
            tmpd.setSeconds(d[0])
            return tmpd.toISOString().substr(11,8)
          }),
          tickAmount: 24,
        }
      }}
      this.$refs.kpi.updateSeries([{
        data: this.getCurrentDeviceHistoricalData[this.kpi].map(d => d[1])
      }], false, true);
      this.loading = false
    },
    async changeDay(num) {
      this.$log.debug(this.filterDate)
      var date = new Date(this.filterDate);
      date.setDate(date.getDate() + num);
      this.$log.debug(date)
      this.filterDate = date

      await this.updateData({ device: this.getCurrentDevice.deviceId, kpi: this.kpi, date: this.date.replaceAll('-','') })
    },
    async changeDatePicker(value) {
      this.$log.debug(value)
      await this.updateData({ device: this.getCurrentDevice.deviceId, kpi: this.kpi, date: value.replaceAll('-','') })
      this.filterDate = new Date(value)
      this.$refs.menu.save(value)
    },
  }
}
</script>

<style>

</style>